import { type ReactNode } from "react";

import {
  Modal as ReactAriaModal,
  type ModalOverlayProps as ReactAriaModalProps,
} from "react-aria-components";

import { useUIVersion } from "#hooks";
import { customTv } from "#utils";

export type ModalSize = "sm" | "md" | "lg" | "xl";

export interface ModalProps extends ReactAriaModalProps {
  className?: string;
  children: ReactNode;
  size?: ModalSize;
}

const modalStyles = customTv({
  base: "border border-outline-decorative bg-background-primary shadow-lg overflow-auto max-h-[90vh] overscroll-none",
  variants: {
    size: {
      sm: "w-full max-w-[400px]",
      md: "w-full max-w-[560px]",
      lg: "w-full max-w-[720px]",
      xl: "w-full max-w-[900px]",
    },
    uiVersion: {
      v1: "rounded-1",
      v2: "rounded-xl",
    },
  },
  defaultVariants: {
    size: "md",
    uiVersion: "v2",
  },
});

export function Modal({ children, className, size = "md" }: ModalProps) {
  const uiVersion = useUIVersion();

  return (
    <ReactAriaModal className={modalStyles({ size, uiVersion, className })}>
      {children}
    </ReactAriaModal>
  );
}
